import { DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

import { I18nLocaleFactory } from '../../../../i18n/i18n.module';
import { I18nService } from '../../../../i18n/i18n.service';

@Pipe({
    name: 'cmpsWpNumber',
})
export class WpNumberPipe implements PipeTransform {
    constructor(private readonly _i18nService: I18nService) {}

    transform(value: any): string | null {
        const digits = value >= 1 || value <= -1 ? '1.0-0' : '1.1-1';
        const locale = I18nLocaleFactory(this._i18nService);
        return new DecimalPipe(locale).transform(value, digits);
    }
}
